import createReactModal from '../../modal/createReactModal'
import { ServiceAppointmentPreview } from './ServiceAppointmentPreview'
import { _ } from '../../gettext'

/**
 * Creates service appointment view component in modal.
 *
 * @param {object|null} reservation
 */
export function createServiceAppointmentPreview (reservation) {
  return createReactModal(
    (modal) => {
      return (<ServiceAppointmentPreview
        reservation={reservation}
        modal={modal}
      />)
    },
    { title: _('Rezervace') + ' ' + reservation.model.subject }
  )
}
